export default __webpack_public_path__ + "static/media/material-pyramid.de9c02c8.pdf";